import { IconWrapper } from '../runtime';
export default IconWrapper('h4', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.7003 8.9331L11.9876 11.6997H13.7003V8.9331ZM14.8003 11.6997V8.05429C14.8003 7.1984 13.6781 6.87915 13.2276 7.60689L10.8161 11.5023C10.4656 12.0686 10.8729 12.7997 11.5388 12.7997H13.7003V14.445C13.7003 14.7488 13.9465 14.995 14.2503 14.995C14.5541 14.995 14.8003 14.7488 14.8003 14.445V12.7997H15.0003C15.3041 12.7997 15.5503 12.5535 15.5503 12.2497C15.5503 11.946 15.3041 11.6997 15.0003 11.6997H14.8003Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M1.75 1.75363V14.2497M9.25 1.75363V14.2497M1.75 8.00168H9.25",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});